import { CLEAN_AUTH, CONNECT_USER, UPDATE_USER } from '../reducers/authReducer'

export const connectUserAction = (data) => ({
  type: CONNECT_USER,
  payload: data,
})

export const updateUserAction = (data) => ({
  type: UPDATE_USER,
  payload: data,
})

export const cleanAuth = () => ({
  type: CLEAN_AUTH,
})
